// A round arrives from three directions - a hub push, the answer to your own write, the fallback poll - and
// they overtake each other. A state read before your write reached the server does not know about it yet,
// which is how tapping the lock used to reopen the field and wipe the number you had typed. Two rules:
// a state older than what is on screen is dropped, and while a write of yours is outstanding nothing is
// rendered at all.
//
// A write counts as outstanding from the keystroke rather than from the request, because the post sits
// behind a debounce and that gap is exactly when somebody else's push lands on the value you are typing.
const INITIATIVE_KEY_PREFIX = "initiative:";

const outstandingWrites: Record<string, boolean> = {};
let outstandingWriteCount = 0;
let renderedEpoch = 0;
let renderedVersion = -1;
let heldRound: RoundResponse | null = null;

function InitiativeLockKey(nameSluggified: string): string {
    return INITIATIVE_KEY_PREFIX + "lock:" + nameSluggified;
}

function InitiativeValueKey(nameSluggified: string): string {
    return INITIATIVE_KEY_PREFIX + "value:" + nameSluggified;
}

function TrackerKey(field: TrackerField, nameSluggified: string): string {
    return field + ":" + nameSluggified;
}

function OfferRound(round: RoundResponse): void {
    HoldRound(round);
    FlushHeldRound();
}

// A restart is the one case where a lower version is not an older state: the new process counts from zero
// again, so a different epoch is taken as it comes.
function HoldRound(round: RoundResponse): void {
    if (round.epoch === renderedEpoch && round.version <= renderedVersion) {
        return;
    }

    if (heldRound && heldRound.epoch === round.epoch && round.version <= heldRound.version) {
        return;
    }

    heldRound = round;
}

function FlushHeldRound(): void {
    if (outstandingWriteCount > 0 || !heldRound) {
        return;
    }

    const round = heldRound;
    heldRound = null;
    renderedEpoch = round.epoch;
    renderedVersion = round.version;
    RenderRound(round);
}

// Keyed rather than counted, so a second keystroke in the same field does not add a hold that nothing will
// ever release.
function HoldWrite(key: string): void {
    if (outstandingWrites[key]) {
        return;
    }

    outstandingWrites[key] = true;
    outstandingWriteCount++;
}

// The answer to your write and a push that arrived meanwhile can both be waiting. Holding both and flushing
// once keeps the older one from flashing past on its way to being replaced.
function ReleaseWrite(key: string, round: RoundResponse | null): void {
    if (outstandingWrites[key]) {
        delete outstandingWrites[key];
        outstandingWriteCount--;
    }

    if (round) {
        HoldRound(round);
    }

    FlushHeldRound();
}

// Every write goes through here. Failing releases as surely as succeeding does, or one dropped request
// freezes the table for good.
function PostRoundWrite(key: string, url: string, data: Record<string, string | number | null>): JQuery.jqXHR {
    HoldWrite(key);

    return jQuery.ajax({
        type: "POST",
        url: url,
        async: true,
        data: data
    }).done(function (round: RoundResponse) {
        ReleaseWrite(key, round);
    }).fail(function () {
        ReleaseWrite(key, null);
    });
}
